import ajax from "./ajax";

export function enqueueProductCreateJob(data) {
  return ajax(`/products/create-job`, {
    method: "POST",
    data,
    // Enqueue may stage payload JSON to GCS; avoid premature abort.
    timeout: 180000,
  });
}

export function getProductCreateJob(jobId) {
  return ajax(`/products/create-job/${jobId}`);
}

export function getProductCreateUploadUrl(jobId, data) {
  return ajax(`/products/create-job/${jobId}/upload-url`, {
    method: "POST",
    data,
  });
}

/**
 * Proxied upload through our API (avoids browser→GCS CORS "Failed to fetch").
 * Large files should be sent in chunks (chunkIndex / chunkTotal) under ~24MB
 * so App Engine's ~32MB request body limit is not hit.
 */
export function uploadProductCreateFile(
  jobId,
  {
    fileKey,
    blob,
    name,
    contentType,
    chunkIndex = 0,
    chunkTotal = 1,
    bytes = null,
  }
) {
  if (!fileKey) {
    throw new Error("fileKey is required.");
  }
  const form = new FormData();
  form.append("fileKey", String(fileKey));
  if (name) form.append("name", name);
  if (contentType) form.append("contentType", contentType);
  form.append("chunkIndex", String(chunkIndex));
  form.append("chunkTotal", String(chunkTotal));
  if (bytes != null) form.append("bytes", String(bytes));
  form.append("file", blob, name || `${fileKey}.png`);
  // Also put fileKey on the query string. App Engine / multer has dropped
  // multipart text fields mid-batch before; the route already reads query.
  const q = new URLSearchParams({
    fileKey: String(fileKey),
    chunkIndex: String(chunkIndex),
    chunkTotal: String(chunkTotal),
  });
  if (name) q.set("name", name);
  if (contentType) q.set("contentType", contentType);
  if (bytes != null) q.set("bytes", String(bytes));
  return ajax(`/products/create-job/${jobId}/upload-file?${q.toString()}`, {
    method: "POST",
    data: form,
    formData: true,
    timeout: 180000,
  });
}

/** Server-side copy of a file this job already uploaded (same print, another color). */
export function copyProductCreateFile(jobId, { fileKey, copyFromFileKey, name }) {
  const form = new FormData();
  form.append("fileKey", String(fileKey));
  form.append("copyFromFileKey", String(copyFromFileKey));
  if (name) form.append("name", name);
  const q = new URLSearchParams({
    fileKey: String(fileKey),
    copyFromFileKey: String(copyFromFileKey),
  });
  if (name) q.set("name", name);
  return ajax(`/products/create-job/${jobId}/upload-file?${q.toString()}`, {
    method: "POST",
    data: form,
    formData: true,
    timeout: 180000,
  });
}

export function completeProductCreateUpload(jobId, data) {
  return ajax(`/products/create-job/${jobId}/complete-upload`, {
    method: "POST",
    data,
  });
}

export function failProductCreateJob(jobId, data) {
  return ajax(`/products/create-job/${jobId}/fail`, {
    method: "POST",
    data,
  });
}
